import React from 'react'
import { css } from '@emotion/css'
import { cssTextareaBorderColor, Textarea, TextareaProps } from './textarea'
import { FormTextProps } from './index'

const cssBubbleIndent = css`
  &::before,
  &::after {
    content: '';
    width: 0px;
    height: 0px;
    position: absolute;
    border-left: 10px solid;
    border-right: 10px solid transparent;
    border-top: 10px solid;
    left: 19px;
    bottom: 0px;
  }
  &::before {
    bottom: -5px;
    border-color: ${cssTextareaBorderColor} transparent;
  }
  &::after {
    bottom: -3px;
    border-color: white transparent;
    width: 0;
  }
`

export function BubbleTextArea(props: FormTextProps & TextareaProps) {
  return (
    <Textarea
      {...props}
      classNameFormTextSecondaryContainer={cssBubbleIndent}
    />
  )
}
